import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {
  replaceMainSiteLinkHostname,
  getModalityFromHostname,
} from "../../services/Utils";
import CheckmarkIcon from "../icons/CheckmarkIcon";
import SurveyStatusPage from "./SurveyStatusPage";

const VITE_CHAT_HOST =
  import.meta.env.VITE_CHAT_HOST || "https://chat.988lifeline.org";
const VITE_SMS_NUMBER = import.meta.env.VITE_SMS_NUMBER || "988";

const AlreadySubmittedPage = () => {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const isSms = getModalityFromHostname(window?.location?.hostname) === "sms";

  const buttonText = isSms
    ? t("alreadySubmitted.smsButton")
    : t("alreadySubmitted.button");
  const buttonHref = isSms
    ? `sms:${VITE_SMS_NUMBER}`
    : replaceMainSiteLinkHostname(t("chatHomeUrl"), VITE_CHAT_HOST);

  return (
    <SurveyStatusPage
      title={t("alreadySubmitted.title")}
      body={t("alreadySubmitted.message")}
      buttonText={buttonText}
      buttonHref={buttonHref}
      color={theme.palette.success.main}
      icon={
        <CheckmarkIcon
          sx={{ fontSize: "60px", color: theme.palette.success.main, mb: 2 }}
        />
      }
    />
  );
};

export default AlreadySubmittedPage;
